import { Link, Outlet, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, ExternalLink } from 'lucide-react';
import { useState } from 'react';
import styles from './Layout.module.css';

const APP_URL = import.meta.env.VITE_APP_URL || 'https://app.console.rivellum.network';

export function Layout() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [toolsDropdownOpen, setToolsDropdownOpen] = useState(false);

  const handleLaunchConsole = () => {
    window.open(APP_URL, '_blank', 'noopener,noreferrer');
  };

  const isActive = (path: string) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className={styles.container}>
      {/* Header */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <Link to="/" className={styles.logo}>
            <div className={styles.logoIcon}>
              <img src="/logo.png" alt="Rivellum" className={styles.logoImage} />
            </div>
            <h1 className={styles.logoTitle}>
              Rivellum Console
            </h1>
          </Link>

          <button 
            className={styles.mobileMenuButton}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <nav className={`${styles.nav} ${mobileMenuOpen ? styles.navOpen : ''}`}>
            <Link 
              to="/" 
              className={`${styles.navLink} ${location.pathname === '/' ? styles.active : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              <span>Home</span>
            </Link>
            <div className={styles.dropdown}>
              <button 
                className={`${styles.navLink} ${styles.dropdownTrigger} ${isActive('/tools') ? styles.active : ''}`}
                onClick={() => setToolsDropdownOpen(!toolsDropdownOpen)}
                onBlur={() => setTimeout(() => setToolsDropdownOpen(false), 200)}
              >
                <span>Tools</span>
                <ChevronDown size={14} className={`${styles.chevron} ${toolsDropdownOpen ? styles.chevronOpen : ''}`} />
              </button>
              {toolsDropdownOpen && (
                <div className={styles.dropdownMenu}>
                  <Link 
                    to="/tools/randomness" 
                    className={styles.dropdownItem}
                    onClick={() => {
                      setToolsDropdownOpen(false);
                      setMobileMenuOpen(false);
                    }}
                  >
                    VRF
                  </Link>
                </div>
              )}
            </div>
            <Link 
              to="/sdk" 
              className={`${styles.navLink} ${isActive('/sdk') ? styles.active : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              <span>SDK Docs</span>
            </Link>
            <button className={styles.connectWalletMobile} onClick={() => { handleLaunchConsole(); setMobileMenuOpen(false); }}>
              <ExternalLink size={18} />
              <span>Launch Console</span>
            </button>
          </nav>

          <div className={styles.headerActions}>
            <button className={styles.connectWallet} onClick={handleLaunchConsole}>
              <ExternalLink size={18} />
              Launch Console
            </button>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className={styles.main}>
        <Outlet />
      </main>

      {/* Footer */}
      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          Rivellum Console v{import.meta.env.VITE_APP_VERSION || '0.1.0'} •{' '}
          <a
            href="https://github.com/rivellumlabs/rivellum"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.footerLink}
          >
            Source repository (GitHub)
          </a>
          <a
            href="https://portal.rivellum.network/docs"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.footerLink}
          >
            Portal documentation
          </a>
        </div>
      </footer>
    </div>
  );
}
